import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavService } from '../../../../services/nav.service';

export const languages = [{
  language: 'English',
  code: 'en',
  type: 'US',
  icon: 'us'
},
{
  language: 'Español',
  code: 'es',
  icon: 'es'
},
{
  language: 'Français',
  code: 'fr',
  icon: 'fr'
},
{
  language: 'Português',
  code: 'pt',
  type: 'BR',
  icon: 'br'
}];

export const selectedLanguage: any = {
  language: 'English',
  code: 'en',
  type: 'US',
  icon: 'us'
};

@Component({
    selector: 'app-languages',
    templateUrl: './languages.component.html',
    styleUrls: ['./languages.component.scss'],
    standalone: false
})
export class LanguagesComponent implements OnInit {

  public language: boolean = false;

  public languages: any[] = languages;

  public selectedLanguage: any = selectedLanguage

  constructor(public navServices: NavService, private translate: TranslateService) {
    let lang = this.languages.find(x => x.code.includes(navigator.language) || navigator.language.includes(x.code)) || this.selectedLanguage;
    this.changeLanguage(lang);
  }
  // 
  ngOnInit() {
  }

  changeLanguage(lang) {
    this.translate.use(lang.code)
    this.selectedLanguage = lang;
  }

}
